import React, { useEffect, useState } from "react";
import { InventoriesTableRow } from "./inventoriesTableRow";

export const InventoriesTable = ({
	data,
	setInventoryToEdit,
	deleteInventory,
	openModal,
}) => {
	const [showData, setShowData] = useState(data);

	useEffect(() => {
		setShowData(data);
	}, [data]);

	// console.log("data", data);

	function handleSearch(e) {
		console.log("e:", e.target.value);
		if (e.target.value === "") {
			return setShowData(data);
		}
		console.log("data: ", data);
		setShowData(
			data.filter(
				// console.log("item: ",item);
				(item) =>
					item.refInventory.toLowerCase().includes(e.target.value) ||
					item.description.toLowerCase().includes(e.target.value)
			)
		);
	}

	return (
		<div>
			<div className="document-search">
				<h2 className="title-search">Buscar</h2>
				<input
					type="search"
					name=""
					id=""
					onChange={handleSearch}
					className="search-box"
				/>
			</div>
			<h3 className="titulo1">Lista de Productos</h3>
			<table className="tabla-procesos">
				<thead>
					<tr className="fila-tabla-procesos">
						<th className="titleTableDocuments03">Referencia</th>
						<th className="titleTableDocuments02">Descripción</th>
						<th className="titleTableDocuments02">Características</th>
						<th className="titleTableDocuments03">Unidad</th>
						{/* <th className="titleTableDocuments03">Acción</th> */}
					</tr>
				</thead>
				<tbody>
					{showData.length > 0 ? (
						showData.map((el) => (
							<InventoriesTableRow
								key={el.id}
								el={el}
								setInventoryToEdit={setInventoryToEdit}
								openModal={openModal}
								deleteInventory={deleteInventory}
							/>
						))
					) : (
						<tr>
							<td colSpan="3">Sin datos</td>
						</tr>
					)}
				</tbody>
			</table>
		</div>
	);
};
